// extracted by mini-css-extract-plugin
export var bodySections = "_ct-8";
export var gray = "_ct-7";
export var green = "_ct-4";
export var iconContainer = "_ct-9";
export var iconWidgetContainer = "_ct-1";
export var phoneIcon = "_ct-2";
export var red = "_ct-5";
export var statusDot = "_ct-3";
export var widgetContainer = "_ct-0";
export var yellow = "_ct-6";